import { render } from "./ExamPaperList.vue?vue&type=template&id=4e0731d8&scoped=true&ts=true"
import script from "./ExamPaperList.vue?vue&type=script&lang=ts"
export * from "./ExamPaperList.vue?vue&type=script&lang=ts"

import "./ExamPaperList.vue?vue&type=style&index=0&id=4e0731d8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0731d8"]])

export default __exports__